import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { useNavigate } from 'react-router-dom'

export default function LoginPage() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await login(email, password)
      navigate('/')
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid credentials')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>PE</div>
        <h1 style={styles.title}>Prospecting Engine</h1>
        <p style={styles.sub}>Sign in to your account</p>

        {error && <div style={styles.errorBanner}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.group}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="you@company.com"
              required
            />
          </div>
          <div style={styles.group}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="••••••••"
              required
            />
          </div>
          <button type="submit" style={styles.btn} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  )
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f3',
  },
  card: {
    background: '#fff',
    border: '0.5px solid #e0dfd8',
    borderRadius: 16,
    padding: '2.5rem 2rem',
    width: 380,
    textAlign: 'center',
  },
  logo: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: '#1a1a1a',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: 16,
    margin: '0 auto 1rem',
    letterSpacing: 1,
  },
  title: {
    fontSize: 20,
    fontWeight: 500,
    margin: '0 0 4px',
    color: '#1a1a1a',
  },
  sub: {
    fontSize: 14,
    color: '#888',
    margin: '0 0 1.5rem',
  },
  errorBanner: {
    background: '#FCEBEB',
    color: '#791F1F',
    border: '0.5px solid #F09595',
    borderRadius: 8,
    padding: '10px 14px',
    fontSize: 13,
    marginBottom: '1rem',
    textAlign: 'left',
  },
  form: { textAlign: 'left' },
  group: { marginBottom: '1rem' },
  label: {
    display: 'block',
    fontSize: 12,
    color: '#666',
    marginBottom: 4,
  },
  input: {
    width: '100%',
    padding: '9px 12px',
    fontSize: 14,
    border: '0.5px solid #ccc',
    borderRadius: 8,
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  },
  btn: {
    width: '100%',
    padding: '10px',
    background: '#1a1a1a',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    marginTop: 8,
  },
}
